import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { salesTargetAPI } from "services/apisService";

const KPIModal = ({ isOpen, onClose, selectedUser, selectedMonth, users, onSuccess }) => {
  const [formData, setFormData] = useState({
    userId: selectedUser?.id || '',
    amount: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (selectedUser) {
      setFormData(prev => ({ ...prev, userId: selectedUser.id }));
    }
  }, [selectedUser]);

 useEffect(() => {
  if (isOpen) {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = '15px';
    setErrorMessage(''); 
    setSuccessMessage('');
    setIsSubmitting(false); 
  } else {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    setIsSubmitting(false); 
  }

  return () => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };
}, [isOpen]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorMessage('');
  setSuccessMessage(''); 
  setIsSubmitting(true); 
  
  try {
    const targetData = {
      amount: parseInt(formData.amount),
      userId: formData.userId,
      month: selectedMonth
    };

    await salesTargetAPI.setSalesTarget(targetData);
    
    setSuccessMessage('Target has been set successfully');
    
    if (onSuccess) {
      onSuccess();
    }
    
    setFormData({
      userId: selectedUser?.id || '',
      amount: ''
    });
    
      setTimeout(() => {
      onClose();
      setSuccessMessage('');
    }, 300);
    
  } catch (error) {
    console.error("Error setting sales target:", error);
    
    if (error) {
      setErrorMessage(error);
    } else {
      setErrorMessage('An error occurred while setting the sales target');
    }
  } finally {
    setIsSubmitting(false); 
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const getFormattedMonthYear = (monthYear) => {
    if (!monthYear) return 'Current Month';
    
    const [year, month] = monthYear.split('-');
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const monthIndex = parseInt(month) - 1;
    return `${monthNames[monthIndex]} ${year}`;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#000] backdrop-blur-[15px] bg-opacity-50 flex items-center justify-center z-50">
      {errorMessage && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-100 text-red-800 px-6 py-3 rounded-md shadow-md text-center z-50 max-w-[90%] sm:max-w-md">
          {"❌  " + errorMessage}
        </div>
      )}

      {successMessage && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-100 text-green-800 px-6 py-3 rounded-md shadow-md text-center z-50 max-w-[90%] sm:max-w-md">
          {"✅  " + successMessage}
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">Set KPI</h3>
          <button
            onClick={onClose}
            className=" hover:bg-red-900 shadow-md rounded-md"
          >
            <IoMdClose className="h-6 w-6 rounded-md bg-red-500 text-white" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Selected User Display */}
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Selected User
            </label>
            <div className="w-full px-3 py-2 bg-blue-100 border border-gray-300 rounded-lg text-gray-800 font-medium">
              {selectedUser?.name || 'No user selected'}
            </div>
          </div>

          {/* Selected Month/Year Display */}
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Selected Month & Year
            </label>
            <div className="w-full px-3 py-2 bg-blue-100 border border-gray-300 rounded-lg text-gray-800 font-medium">
              {getFormattedMonthYear(selectedMonth)}
            </div>
          </div>

          {/* Amount Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="Enter KPI amount"
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 transition-colors duration-150"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
              style={{ backgroundColor: '#3985b6' }}
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                  Setting...
                </>
              ) : (
                'Set KPI'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default KPIModal;